import * as React from 'react'
import { styled } from 'next-yak'

import { lightweight, standalone, type SymbolProps } from '../../spritesheetUtils'
import { Icon } from '../Icon'
import { type SpecificIconProps } from '../types'

const AUDIO_PATH = (
  <g>
    <path
      id="Vector"
      d="M14.3069 16.5H1.69312C0.761905 16.5 0 15.7381 0 14.8069V2.19312C0 1.2619 0.761905 0.5 1.69312 0.5H14.3069C15.2381 0.5 16 1.2619 16 2.19312V14.8069C16 15.7381 15.2381 16.5 14.3069 16.5ZM2.5679 15.0891H13.4415C14.0811 15.0891 14.5985 14.5717 14.5985 13.9321V3.0679C14.5985 2.42828 14.0811 1.91093 13.4415 1.91093H2.5679C1.92828 1.91093 1.41093 2.42828 1.41093 3.0679V13.9321C1.41093 14.5717 1.92828 15.0891 2.5679 15.0891Z"
    />
    <path
      id="Vector_2"
      d="M4.42046 7.48837C4.42046 7.09875 4.10461 6.7829 3.71499 6.7829C3.32537 6.7829 3.00952 7.09875 3.00952 7.48837V9.46367C3.00952 9.85329 3.32537 10.1691 3.71499 10.1691C4.10461 10.1691 4.42046 9.85329 4.42046 9.46367V7.48837Z"
    />
    <path
      id="Vector_3"
      d="M6.65044 5.23159C6.65044 4.84197 6.33459 4.52612 5.94497 4.52612C5.55535 4.52612 5.2395 4.84197 5.2395 5.23159V11.816C5.2395 12.2056 5.55535 12.5214 5.94497 12.5214C6.33459 12.5214 6.65044 12.2056 6.65044 11.816V5.23159Z"
    />
    <path
      id="Vector_4"
      d="M8.8416 6.07796C8.8416 5.68835 8.52575 5.3725 8.13613 5.3725C7.74651 5.3725 7.43066 5.68835 7.43066 6.07796V10.7811C7.43066 11.1707 7.74651 11.4865 8.13613 11.4865C8.52575 11.4865 8.8416 11.1707 8.8416 10.7811V6.07796Z"
    />
    <path
      id="Vector_5"
      d="M12.9891 5.4855C12.9891 5.09588 12.6732 4.78003 12.2836 4.78003C11.894 4.78003 11.5781 5.09588 11.5781 5.4855V11.1763C11.5781 11.5659 11.894 11.8817 12.2836 11.8817C12.6732 11.8817 12.9891 11.5659 12.9891 11.1763V5.4855Z"
    />
    <path
      id="Vector_6"
      d="M10.8826 8.11935C10.8826 7.72973 10.5668 7.41388 10.1771 7.41388C9.78753 7.41388 9.47168 7.72973 9.47168 8.11935V8.4956C9.47168 8.88521 9.78753 9.20106 10.1771 9.20106C10.5668 9.20106 10.8826 8.88521 10.8826 8.4956V8.11935Z"
    />
  </g>
)

const ID = 'audio-stroke-glyph-icon'

export function AudioSymbol({ id = ID, ...props }: SymbolProps): React.ReactElement<SymbolProps> {
  return (
    <symbol {...props} id={id} viewBox="0 0 16 17">
      {AUDIO_PATH}
    </symbol>
  )
}

const AudioStandaloneContent = standalone(AudioSymbol, ID)

export const Audio = styled(function AudioComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="audio">
      <AudioStandaloneContent />
    </Icon>
  )
})``

export const AudioLightweight = styled(function AudioComponent(props: SpecificIconProps) {
  return (
    <Icon {...props} name="audio-light-weight">
      {lightweight(ID)}
    </Icon>
  )
})``
